<template>
    <div class="issue-detail-module">
        <div class="issue-card">
            <div class="item-head">
                <img class="avatar" :src="detail.avatar" alt="" />
                <div class="meta">
                    <div class="name">{{ detail.inspectorName }}</div>
                    <div class="time">{{ detail.createDate }}</div>
                </div>
            </div>
            <div class="desc">{{ detail.explanation }}</div>
            <div class="img-grid" v-if="detail.fileInfoList && detail.fileInfoList.length > 0">
                <div v-for="(n, index) in detail.fileInfoList" :key="index" class="img-ph" @click="openPreview(detail.fileInfoList, index)">
                    <img v-if="isImage(n.url)" :src="n.url" alt="" />
                    <video v-else-if="isVideo(n.url)" :src="n.url" controls="controls"></video>
                </div>
            </div>
            <div class="check-row">
                <span class="label">检查项：</span>
                <span class="value" :class="{ ellipsis: !detail.expanded }">{{ detail.questionName }}</span>
            </div>
            <div class="expand" v-if="needExpand" @click="toggleExpand">{{ detail.expanded ? '收起' : '展开' }}</div>
        </div>

        <div class="line"></div>

        <div class="reply-section">
            <div class="reply-title">整改回复</div>
            <div v-if="!hasReply" class="reply-empty">
                还没有人回复哦~
            </div>
            <div v-else class="reply-list">
                <div class="reply-item">
                    <div class="reply-head">
                        <img class="reply-ava" :src="replyInfo.avatarUrl" />
                        <div class="reply-meta">
                            <div class="reply-name">{{ replyInfo.applyUserName }}</div>
                            <div class="reply-time">{{ replyInfo.applyDate }}</div>
                        </div>
                    </div>
                    <div class="reply-text">{{ replyInfo.applyReview }}</div>
                    <div class="reply-img-grid" v-if="replyInfo.fileInfoList && replyInfo.fileInfoList.length > 0">
                        <div v-for="(m, n) in replyInfo.fileInfoList" :key="n" class="reply-img-ph" @click="openPreview(replyInfo.fileInfoList, n)">
                            <img v-if="isImage(m.url)" :src="m.url" alt="" />
                            <video v-else-if="isVideo(m.url)" :src="m.url" controls="controls"></video>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="reply-section" v-if="hasAudit">
            <div class="reply-title">审核回复</div>
            <div class="reply-list">
                <div class="reply-item">
                    <div class="reply-head">
                        <img class="reply-ava" :src="auditInfo.avatarUrl" />
                        <div class="reply-meta">
                            <div class="reply-name">{{ auditInfo.auditUserName }}</div>
                            <div class="reply-time">{{ auditInfo.auditDate }}</div>
                        </div>
                    </div>
                    <div class="reply-text">{{ auditInfo.auditReview }}</div>
                    <div class="reply-img-grid" v-if="auditInfo.fileInfoList && auditInfo.fileInfoList.length > 0">
                        <div v-for="(m, n) in auditInfo.fileInfoList" :key="n" class="reply-img-ph" @click="openPreview(auditInfo.fileInfoList, n)">
                            <img v-if="isImage(m.url)" :src="m.url" alt="" />
                            <video v-else-if="isVideo(m.url)" :src="m.url" controls="controls"></video>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="reply-bar" v-if="showReplyBar && ((postType != 9 && postType != 10 && detail.rectifyStatus == 0) || ((postType == 9 || postType == 10) && detail.auditStatus != 2))">
            <div class="flex flex-y-center">
                <input ref="replyInput" v-model="replyText" class="reply-input" placeholder="添加回复：" type="text" inputmode="text" enterkeyhint="send" @keydown.enter.prevent="onEnterSend" @compositionstart="onCompositionStart" @compositionend="onCompositionEnd" />
                <van-icon v-if="isWeCom && isAndroid" name="photo-o" class="reply-icon" @click="showUploadSheet = true" />
                <van-icon v-else name="photo-o" class="reply-icon" @click="onPickMedia" />
                <van-uploader ref="uploader" v-show="false" :after-read="onAfterRead" accept="image/*,video/*" multiple :max-count="20" result-type="dataUrl" />
            </div>
            <div class="reply-upload-grid" v-if="replyMedias.length > 0">
                <div class="upload-item" v-for="(m, idx) in replyMedias" :key="idx">
                    <div class="upload-ph">
                        <img v-if="isImage(m.url)" :src="m.url" alt="" />
                        <video v-else-if="isVideo(m.url)" :src="m.url" muted playsinline></video>
                        <van-icon class="del" name="delete-o" size="22px" color="#ff4545" @click="onDelFile(idx)" />
                    </div>
                    <div class="click-mask" @click="openPreview(replyMedias, idx)"></div>
                </div>
            </div>
        </div>

        <div class="bottom-actions" v-if="!showReplyBar && detail.rectifyStatus != 2 && (postType == 9 || postType == 10)">
            <div class="action-item" @click="openReplyBar">
                <div class="action-icon">
                    <img src="https://mlty-wecom-beauty.oss-cn-shanghai.aliyuncs.com/20251201/reply.png" alt="">
                </div>
                <div class="action-text">回复</div>
            </div>
            <div class="action-item" @click="markDone">
                <div class="action-icon">
                    <img src="https://mlty-wecom-beauty.oss-cn-shanghai.aliyuncs.com/20251201/accomplish.png" alt="">
                </div>
                <div class="action-text">完成</div>
            </div>
        </div>

        <media-preview v-if="showPreview" v-model="showPreview" :list="previewList" :start-index="previewIndex" />

        <!-- 仅用于 ActionSheet 选「上传视频」时触发，复用与上方一致的上传逻辑 -->
        <van-uploader ref="videoUploader" v-show="false" :after-read="onAfterRead" accept="video/*" multiple :max-count="20" result-type="dataUrl" />
        <van-action-sheet v-model="showUploadSheet" :actions="uploadSheetActions" cancel-text="取消" @select="onUploadSheetSelect" />

    </div>
</template>

<script>
    import request from '@/utils/request'
    import { Toast } from 'vant'
    import MediaPreview from './components/MediaPreview.vue'
    import { debounce } from 'lodash'
    import OSS from 'ali-oss'
    import { timeToDate2 } from "@/utils/util.js";
    import { isImage, isVideo } from '@/utils/index.js'
    import { getUserLogin } from '@/api/home';
    import { isWeCom, isAndroid, uploadImage } from '@/utils/wxCodeAuth'

    export default {
        name: 'issueDetail',
        components: { MediaPreview },
        data() {
            return {
                postType: this.$store.state.user.permissions.postType,
                id: null,
                detail: {
                    role: '', time: '', desc: '', imgCount: 0, itemTitle: '', expanded: false, avatar: ''
                },
                replyInfo: {},
                auditInfo: {},
                replyText: '',
                replyMedias: [],
                showPreview: false,
                previewList: [],
                previewIndex: 0,
                isComposing: false,
                showReplyBar: false,
                itemTitleLimit: 42,
                isReply: 1, // 是回复还是完成操作, - 1: 回复, 0: 完成
                client: null,
                domain: null,
                employeeInfo: {},
                // 判断是否为企微环境
                isWeCom: isWeCom(),
                // 是否为安卓设备
                isAndroid: isAndroid(),
                showUploadSheet: false,
                uploadSheetActions: [
                    { name: '上传视频', value: 'video' },
                    { name: '上传图片', value: 'image' },
                ],
            }
        },
        created() {
            this.id = this.$route.query.id;
            this.setOSS()
            getUserLogin().then(res => {
                this.employeeInfo = {
                    empNo: res.data.empNo,
                    name: res.data.name
                };
            });
            this.init();
            this.showReplyBar = (this.postType != 9 && this.postType != 10) ? true : false;
        },
        computed: {
            needExpand() {
                const s = this.detail.questionName || ''
                let len = 0
                for (const ch of s) {
                    len += /[^\x00-\xff]/.test(ch) ? 2 : 1
                }
                return len >= this.itemTitleLimit
            },
            hasReply() {
                return Object.keys(this.replyInfo).length > 0
            },
            hasAudit() {
                return Object.keys(this.auditInfo).length > 0
            }
        },
        methods: {
            setOSS() {
                request({ url: `/aliyun/token`, method: 'get' })
                    .then((res) => {
                        this.client = new OSS({
                            region: res.data.region,
                            accessKeyId: res.data.accessKeyId,
                            accessKeySecret: res.data.accessKeySecret,
                            stsToken: res.data.securityToken,
                            bucket: res.data.bucket
                        })
                        this.domain = res.data.domain
                    })
                    .catch((error) => {
                        Toast({ position: 'top', message: String(error || '获取上传凭证失败') })
                    })
            },
            init() {
                request.get(`/rectify-audit/queryById?id=${this.id}`).then(res => {
                    if (res.code != 0) {
                        Toast({ position: 'top', message: res.msg || '获取详情失败' })
                        return
                    }
                    this.detail = {
                        ...res.data,
                        expanded: false,
                        avatar: res.data.headImg || 'https://staticpos.beautyfarm.com.cn/pos_wechat/shop/head.png'
                    }
                    this.replyInfo = res.data.rectifyApplyInfo || {}
                    this.auditInfo = res.data.rectifyAuditInfo || {}
                    this.replyMedias = []
                })

            },
            toggleExpand() {
                this.detail.expanded = !this.detail.expanded
            },
            sendReply: debounce(function () {
                const text = (this.replyText || '').trim()
                if (!text && this.isReply == 1) {
                    Toast({ position: 'top', message: '请输入回复内容' })
                    return
                }
                let params = {
                    empName: this.employeeInfo.name,
                    empNo: this.employeeInfo.empNo,
                    rectifyFileList: this.replyMedias && this.replyMedias.length > 0 ? this.replyMedias.map(m => ({
                        bussType: this.postType == 1 ? 1 : 2,
                        url: m.url
                    })) : [],
                    rectifyReview: this.replyText,
                    rectifyId: this.id
                }
                request.post(this.postType == 1 ? '/rectify-audit/rectify-apply' : '/rectify-audit/rectify-audit', params).then(res => {
                    if (res.code !== 0) {
                        Toast({ position: 'top', message: res.msg || (this.postType == 1 ? '申请失败' : this.isReply ? '回复失败' : '完成失败') })
                        return
                    }
                    this.replyText = ''
                    this.replyMedias = []
                    Toast({ position: 'top', message: this.postType == 1 ? '申请成功' : this.isReply ? '已回复' : '已完成' })
                    this.$nextTick(() => {
                        const input = this.$refs.replyInput
                        if (input && typeof input.blur === 'function') input.blur()
                    })
                    this.showReplyBar = false
                    this.init()
                }).catch(err => {
                    Toast({ position: 'top', message: this.postType == 1 ? '申请失败' : this.isReply ? '回复失败' : '完成失败' })
                })
            }, 1000, { 'leading': true, 'trailing': false }),
            onPickMedia() {
                const input = this.$refs.uploader && this.$refs.uploader.$el.querySelector('input')
                if (input) input.click()
            },
            onAfterRead(file) {
                const files = Array.isArray(file) ? file : [file]
                if (!this.client || !this.domain) {
                    Toast({ position: 'top', message: '上传凭证获取失败，请稍后重试' })
                    return
                }
                Toast.loading({ message: '上传中...', forbidClick: true, duration: 0 })
                files.forEach(async f => {
                    console.log(f)
                    const raw = f.file || f
                    const name = raw && raw.name ? raw.name : `file_${Date.now()}`
                    const point = name.lastIndexOf('.')
                    const suffix = point >= 0 ? name.substr(point) : ''
                    const base = point >= 0 ? name.substr(0, point) : name
                    const dateName = raw && raw.lastModified ? raw.lastModified : Date.now()
                    const fileNames = `${base}${dateName}${suffix}`
                    const datefile = timeToDate2()
                    const objectKey = `/rectify/${datefile}/${fileNames}`
                    try {
                        await this.client.multipartUpload(objectKey, raw)
                        const url = this.domain + objectKey
                        this.replyMedias.push({ fileType: raw.type, url })
                    } catch (e) {
                        Toast({ position: 'top', message: '上传失败' })
                    }
                })
                Toast.clear()
            },
            openPreview(list, idx) {
                const safe = Array.isArray(list) ? list : []
                this.previewList = safe.map(x => ({ type: x.type == 1 ? 'image' : 'video', url: x.url }))
                this.previewIndex = Number(idx) || 0
                this.showPreview = true
            },
            removeMedia(idx) {
                this.replyMedias.splice(idx, 1)
            },
            onCompositionStart() {
                this.isComposing = true
            },
            onCompositionEnd() {
                this.isComposing = false
            },
            onEnterSend() {
                if (this.isComposing) return
                this.sendReply()
            },
            openReplyBar() {
                this.isReply = true
                this.showReplyBar = true
                this.$nextTick(() => {
                    const input = this.$refs.replyInput
                    if (input && typeof input.focus === 'function') input.focus()
                })
            },
            markDone() {
                this.isReply = false
                this.sendReply()
            },
            onDelFile(i) {
                this.replyMedias.splice(i, 1)
            },
            isImage,
            isVideo,
            onUploadSheetSelect(action) {
                this.showUploadSheet = false;
                if (action.value === 'video') {
                    this.$nextTick(() => {
                        const el = this.$refs.videoUploader;
                        if (el && el.$el) {
                            const input = el.$el.querySelector('input[type="file"]');
                            if (input) input.click();
                        }
                    });
                } else if (action.value === 'image') {
                    uploadImage(20).then(res => {
                        Toast('文件上传成功')
                        res.forEach(url => {
                            this.replyMedias.push({
                                url
                            })
                        })
                    })
                }
            },
        }
    }
</script>

<style scoped lang="less">
    ::-webkit-scrollbar {
        display: none;
    }

    .issue-detail-module {
        background: #fff;
        height: 100%;
        font-family: PingFangSC, PingFang SC;
        padding-bottom: 100px;
        overflow: auto;
    }

    .issue-card {
        background: #fff;
        padding: 30px;
    }

    .item-head {
        display: flex;
        align-items: center;
    }

    .avatar {
        width: 92px;
        height: 92px;
        border-radius: 50%;
        object-fit: cover;
    }

    .meta {
        margin-left: 30px;
    }

    .name {
        color: #35434c;
        font-size: 30px;
    }

    .time {
        color: #A0ACB5;
        font-size: 26px;
        margin-top: 13px;
    }

    .desc {
        color: #35434c;
        font-size: 28px;
        margin: 32px 0;
        white-space: pre-wrap;
        word-wrap: break-word;
        word-break: break-all;
        line-height: 1.5;
    }

    .img-grid {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 30px;
        margin-bottom: 30px;
    }

    .img-ph {
        width: 150px;
        height: 150px;
        border-radius: 4px;
    }

    .img-ph img,
    .img-ph video {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .check-row {
        display: flex;
        color: #35434c;
    }

    .label {
        color: #35434C;
        font-size: 28px;
    }

    .value {
        font-size: 28px;
        flex: 1;
    }

    .ellipsis {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    .expand {
        color: #0D73E4;
        font-size: 28px;
        margin-top: 20px;
        text-align: right;
    }

    .line {
        width: 100%;
        height: 20px;
        background: #F9FAFC;
        box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0);
    }

    .reply-section {
        background: #fff;
        padding: 20px 30px 40px;
    }

    .reply-title {
        color: #35434c;
        font-size: 28px;
        margin-bottom: 18px;
    }

    .reply-empty {
        text-align: center;
        color: #35434C;
        font-size: 30px;
        margin-top: 240px;
    }

    .reply-add-btn {
        margin-top: 50px;
        width: 520px;
        height: 90px;
        border-radius: 44px;
        background: #333F48;
        border: none;
    }

    .reply-item {
        padding: 14px 0;
        border-top: 1px solid #eef1f3;
    }

    .reply-item:first-child {
        border-top: none;
    }

    .reply-head {
        display: flex;
        align-items: center;
    }

    .reply-ava {
        width: 92px;
        height: 92px;
        border-radius: 50%;
        object-fit: cover;
    }

    .reply-meta {
        margin-left: 30px;
    }

    .reply-name {
        color: #35434C;
        font-size: 30px;
    }

    .reply-time {
        color: #A0ACB5;
        font-size: 24px;
        margin-top: 13px;
    }

    .reply-text {
        color: #35434c;
        font-size: 26px;
        margin-top: 10px;
    }

    .reply-img-grid {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 30px;
        margin-top: 18px;
    }

    .reply-img-ph {
        width: 150px;
        height: 150px;
        border-radius: 4px;
    }

    .reply-img-ph img,
    .reply-img-ph video {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .reply-bar {
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        padding: 35px 30px 20px;
        background: #F2F2F2;
    }

    .reply-input {
        flex: 1;
        height: 64px;
        border-radius: 8px;
        border: 1px solid #eef1f3;
        background: #fff;
        padding: 0 12px;
        font-size: 28px;
        outline: none;
    }

    .reply-icon {
        font-size: 48px;
        color: #a0acb5;
        margin: 0 12px;
    }

    .send-btn {
        flex: none;
    }

    .reply-upload-grid {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 30px;
        padding: 0 30px 20px;
        background: #F2F2F2;
        margin-top: 40px;
    }

    .upload-item {
        position: relative;
        width: 100px;
        height: 100px;
    }

    .upload-ph {
        width: 100%;
        height: 100%;
        border-radius: 4px;
    }

    .upload-ph img,
    .upload-ph video {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .del {
        position: absolute;
        top: 5px;
        right: 5px;
        bottom: 0;
        z-index: 10;
    }

    .click-mask {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
    }

    .del-dot {
        position: absolute;
        right: -8px;
        top: -8px;
        width: 36px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        color: #fff;
        background: #333;
        border-radius: 50%;
        font-size: 24px;
    }

    .bottom-actions {
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        background: #F2F2F2;
        padding: 30px;
        display: flex;
        justify-content: space-around;
        align-items: center;
    }

    .action-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        color: #35434c;
    }

    .action-icon {
        width: 70px;
        height: 70px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #333F48;
    }

    .action-icon img {
        width: 100%;
        height: 100%;
    }

    .action-text {
        margin-top: 6px;
        font-size: 28px;
        color: #35434C;
    }
</style>
